import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgPalette(props) {
	return (
		<SvgIcon {...props}>
			<g stroke="currentColor" strokeWidth={1.2} fill="none" fillRule="evenodd">
				<path d="M12 21c1.22 0-2-3 0-5.5s9 2.5 9-3.5a9 9 0 10-9 9z" />
				<g transform="translate(4 4.72)">
					<circle
						transform="rotate(-17 10.522 2.5)"
						cx={10.522}
						cy={2.5}
						r={1.5}
					/>
					<circle
						transform="rotate(-17 5.448 3.006)"
						cx={5.448}
						cy={3.006}
						r={1.5}
					/>
					<circle
						transform="rotate(-17 2.5 7.044)"
						cx={2.5}
						cy={7.044}
						r={1.5}
					/>
				</g>
			</g>
		</SvgIcon>
	)
}

export default SvgPalette
